import { createElement } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

// keeps editor formatting (colors, image sizes, callouts); scripts, handlers and unsafe urls are still stripped
const styledSchema = {
	...defaultSchema,
	attributes: {
		...defaultSchema.attributes,
		"*": [
			...(defaultSchema.attributes?.["*"] ?? []),
			"style",
			"className",
			"data*",
		],
	},
};

export function markdownToHtml(
	input: string | null | undefined,
	allowStyling = false,
): string {
	if (!input) return "";

	return renderToStaticMarkup(
		createElement(
			ReactMarkdown,
			{
				remarkPlugins: [remarkGfm, remarkBreaks],
				rehypePlugins: [
					rehypeRaw,
					allowStyling ? [rehypeSanitize, styledSchema] : rehypeSanitize,
				],
			},
			input,
		),
	);
}
